import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { MedicamentoList, MedicamentoView } from '../core/_models'
import { getMedicamentoById } from '../core/_requests'
import { medicamentosColumns } from './columns/_columns'
import { MedicamentoExpandedRow } from './columns/MedicamentoExpandedRow'
import { useT } from '_metronic/i18n/Metronici18n'

export const MedicamentosTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => medicamentosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.nome.trim()
          ? `Nenhum medicamento encontrado para “${filters.nome.trim()}”`
          : 'Nenhum medicamento nesta situação'
      }
      description='Revise o nome digitado ou a situação selecionada.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum medicamento cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro medicamento.'
    />
  )

  return (
    <CustomTable<MedicamentoList>
      id='kt_table_medicamentos'
      ariaLabel={t('medicamento.plural')}
      itemLabel={{
        singular: t('medicamento.label.lowercase'),
        plural: t('medicamento.plural.lowercase'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
      // Detalhe completo (código, laboratório, cadastro) vem do endpoint do medicamento.
      enableExpand
      onExpandFetch={(row) => getMedicamentoById(row.original.id)}
      getExpandLabel={(row) => row.nome || `medicamento ${row.id}`}
      renderExpand={(data: MedicamentoView, loading) => (
        <MedicamentoExpandedRow data={data} isLoading={loading} />
      )}
    />
  )
}
